import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '1rem',
    textAlign: 'justify',
    height: '100%',
    gap: '2rem',
    minWidth: 500,
  },
  
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '2rem',
    border: `1px solid ${Colors.gray}`,
    borderRadius: '3px',
    textAlign: 'justify',
    height: '100%',
    gap: '2rem',
  },
  
  subject: {
    padding: '1.5rem',
    borderRadius: 3,
    backgroundColor: Colors.lightGray,
    '& > p > span': {
      fontWeight: 600,
    },
  },
  
  buttonsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '2rem',
  },
}))

export default styles
